//平台方管理
export default [
    {
        path: 'platformManagement',
        alias: '',
        name: 'platformManagement',
        meta: {
            title: '平台方管理',
            icon: 'platformManagement'
        },
        hidden: false,
        component: () => import("@/views/operate/platformManagement/index.vue"),
        children: [{
            alias: '',
            path: 'platform',
            name: 'platform',
            meta: {
                title: '平台方',
                icon: 'platform'
            },
            hidden: false,
            component: () => import("@/views/operate/platformManagement/platform.vue"),
        },
        {
            path: 'addPlatform',
            name: 'addPlatform',
            meta: {
                title: '新增平台方',
                icon: 'platform'
            },
            hidden: true,
            component: () => import("@/views/operate/platformManagement/addPlatform.vue"),
        }]
    }

]